export const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

// export function formatCurrency(value) {

//   const stripped = stripToNumbersAndDot(value)
//   // Ensure the input is a number by trying to convert it.
//   // console.log('stripped: ', stripped)
//   const number = parseFloat(stripped);
//   // console.log('number: ', number)
//   // Check if the conversion was successful, just to avoid printing money out of thin air.
//   if (isNaN(number)) {
//     return
//   }
//   // console.log('amount: ', "$" + parseFloat(number).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'));
//   return "$" + parseFloat(number).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
// }

export function formatCurrency(value) {
  const stripped = stripToNumbersAndDot(value);
  // console.log('Stripped:', stripped); // Debugging

  const number = parseFloat(stripped);
  // console.log('Parsed number:', number); // Debugging

  if (isNaN(number)) {
    // console.warn('Invalid number:', value); // Debugging
    return '$0.00'; // Instead of returning nothing, return a fallback value
  }

  return "$" + number.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

export const stripToNumbersAndDot = (input) => {
  if (input == null) return ''; // Handle null/undefined
  if (typeof input === 'number') return input.toString(); // Convert numbers to strings
  if (typeof input !== 'string') return ''; // Return empty for other invalid types
  return input.replace(/[^0-9.]/g, ''); // Strip non-numeric, non-dot characters
};
// const stripToNumbersAndDot = (str) => {
//   if (typeof str !== 'string') {
//     return ''; // or any default value you'd like to return when input is not a string
//   }
//   return str.replace(/[^0-9.]/g, '');
// };

export function convertCurrencyToDouble(currency){
  if (!currency) return 0
  // console.log('calculating currency: ', currency)
  if (currency) {
    try {
      let replaced = currency.toString().replace(/[^0-9.-]+/g,"");
      if (replaced) {
        return parseFloat(replaced)
      } else {
        return 0
      }
    } catch (err) {
      console.log(err)
      return currency
    } finally {
      // setIsLaborDataLoading(false)
    }
  }
  return 0;
}

// This function converts numerical rates to formatted currency strings
export const formatCurrencyNumeric = (amount) => {
  // If the amount is missing or falsy, return "N/A"
  if (!amount) return "N/A";

  // Remove commas from the amount, if any, and ensure it is a valid number
  const numericAmount = parseFloat(amount.toString().replace(/,/g, ''));
  
  // Check if the amount is a valid number after cleaning
  if (isNaN(numericAmount)) return "Invalid amount";

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(numericAmount);
};

export const convertCurrencyToFloat = (currencyString) => {
  // Remove any non-digit characters from the string
  const cleanString = currencyString.toString().replace(/[^0-9.-]+/g, '');

  // Parse the cleaned string as a float
  const floatValue = parseFloat(cleanString);

  return floatValue;
};